<template>
<div class="bytee-quiz">
  <h3>About</h3>
  <p>Finding good preparation questions for any Scrum certifications is not easy.</p>
  <p>The official Scrum.org open assessments are a good starting point, but the exams are often
    much harder, and many people get a false sense of security.
  </p>
  <p>The internet is full with websites publishing Scrum questions but often include
    <b>outdated content, wrong answers,and no explanations.</b> It is not even clear who
    is behind the questions. The practice tests from Mikhail Lapshin are also a
    good alternative, but for many, not enough.</p>
  <p>Scrum <b>practice tests are a tool, NOT a solution</b> to passing the exam.
  Use them to understand which aspects of Agile, Scrum and the Scrum Guide are still unclear.
  <b>Study the Scrum Guide, don't memorize questions and answers.</b>
  </p>
  <p>I am Valentin Despa, an Agile enthusiast, developer and educator. I have passed
    PSM™ I, PSM™ II, PSM™ III, PSPO™ I, and PSPO™ II.</p>
  <p>If you want to get in touch with me, fill out
    <a href="https://forms.gle/9SizSHuuyVeRqNyPA">this contact form</a>
    or <a href="https://www.linkedin.com/in/vdespa/">send me a message on LinkedIn</a>.
    I cannot guarantee a reply, but I will do my best.</p>
</div>
</template>

<script>

export default {
  name: 'about',
  components: {},
};
</script>

<style>
</style>
